export default __webpack_public_path__ + "static/MerriweatherSans-BoldItalic-4c718774e6fe0e127848c577d2fae6aa.ttf";